import { Text } from "@overmap-ai/blocks"
import type { Project } from "@overmap-ai/common"
import {
	type ColumnDef,
	getCoreRowModel,
	getSortedRowModel,
	type TableOptions,
	useReactTable,
} from "@tanstack/react-table"
import { useMemo } from "react"

import { formatTimestampDate } from "../../../utils/date"
import { ColumnSortButton, ColumnSortIcon } from "../components"

export const useProjectTableColumns = () => {
	return useMemo<ColumnDef<Project>[]>(
		() => [
			{
				id: "name",
				accessorKey: "name",
				enableHiding: true,
				meta: {
					plainHeader: "Name",
				},
				header({ column }) {
					return (
						<ColumnSortButton column={column} variant="ghost" size="sm" accentColor="base">
							Name
							<ColumnSortIcon sortDirection={column.getIsSorted()} />
						</ColumnSortButton>
					)
				},
				cell: function Cell({ row }) {
					const project = row.original

					return <Text>{project.name}</Text>
				},
			},
			{
				id: "created_at",
				accessorFn: (project) => project.created_at,
				meta: {
					plainHeader: "Created",
				},
				header({ column }) {
					return (
						<ColumnSortButton column={column} variant="ghost" size="sm" accentColor="base">
							Created
							<ColumnSortIcon sortDirection={column.getIsSorted()} />
						</ColumnSortButton>
					)
				},
				cell: ({ getValue }) => {
					return (
						<Text accentColor="base" className="whitespace-nowrap">
							{formatTimestampDate(getValue<string>())}
						</Text>
					)
				},
			},
		],
		[],
	)
}

export const useProjectTable = (args: Omit<TableOptions<Project>, "getCoreRowModel">) => {
	return useReactTable<Project>({
		...args,
		getCoreRowModel: getCoreRowModel(),
		getSortedRowModel: getSortedRowModel(),
	})
}
